import { html, unsafeHTML } from "../../../../_ovlclient/src"
import { FieldSetVal } from "../../../../_ovlclient/src/library/forms/fieldapi"
import { FormIsLocked } from "../../../../_ovlclient/src/library/forms/formapi"
import { ProcessIsRunning } from "../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"

import { T } from "../../../../_ovlclient/src/textapi"
import { FetchException } from "../../../src/effects"
import { FocusSet } from "../../../src/global/globalapi"
import { isMobile } from "../../../src/global/globals"
import { DialogClose } from "../../../src/library/dialog/dialogapi"
import { DialogGet } from "../../../src/library/dialog/helpers"
import { SYSDialogBase } from "../../../src/library/dialog/sysdialog2base"
import { DialogGetParts } from "../../../src/library/dialog/sysdialogholder"

export type LoginFormState = {}

export class DialogSYSTOTP extends SYSDialogBase {
  keyDownHandlerAdded: boolean

  getBody = () => {
    let message
    let topPart
    let codeManualKey

    if (this.dialogState.data.Message) {
      message = unsafeHTML(message)
    }

    if (message) {
      message = html`<p class="ovltotpmessage">${message}</p>`
    }
    if (this.dialogState.data.SetupQrCodeImageUrl) {
      topPart = html`
        <p class="ovltotpinstruction">${T("SYSTOTPInstruction")}</p>
        <img src="${this.dialogState.data.SetupQrCodeImageUrl}" />
      `
    }
    if (this.dialogState.data.SetupManualCode) {
      codeManualKey = html`<div class="ovltotpmanualkey">
        ${this.dialogState.data.SetupManualCode}
      </div> `
    }
    let validForText
    if (
      this.dialogState.data.Type === "TOTPLogin" &&
      this.dialogState.data.ValidForDays > 0
    ) {
      validForText = html`<p class="ovltotpvaliditytext">
        ${T("SYSTOTPValidityText", this.dialogState.data.ValidForDays)}
      </p>`
    }
    let totpDigits = html`<p class="ovltotpdigitsinstruction">
        ${T("SYSTOTPDigitsInstruction")}
      </p>

      <div class="ovltotpdigits">
        <ovl-textbox .props=${() => this.formState.fields.TOTPDigit1}>
        </ovl-textbox>
        <ovl-textbox .props=${() => this.formState.fields.TOTPDigit2}>
        </ovl-textbox>
        <ovl-textbox .props=${() => this.formState.fields.TOTPDigit3}>
        </ovl-textbox>
        <ovl-textbox .props=${() => this.formState.fields.TOTPDigit4}>
        </ovl-textbox>
        <ovl-textbox .props=${() => this.formState.fields.TOTPDigit5}>
        </ovl-textbox>
        <ovl-textbox .props=${() => this.formState.fields.TOTPDigit6}>
        </ovl-textbox>
      </div> `

    return html`<div class="totp totptype__${this.dialogState.data.Type}">
      ${message} ${topPart} ${codeManualKey} ${totpDigits} ${validForText}
    </div>`
  }
  getFooter = () => {
    return html`<button
      @click=${async (e) => {
        DialogClose(this.dialog, {
          instance: this.dialogInstance,
          resolveValue: { TOTPCanceled: true },
        })
      }}
      title="${T("SYSCancel")}"
      class="fd-button fd-button--negative"
    >
      <i class="sap-icon--decline"></i>
    </button>`
  }

  async getUI() {
    let dialogHolderParams: DialogGetParts
    let type = this.dialogState.data.Type
    let titleKey = `SYSTOTPTitle${type}`
    if (!this.state.ovl.language.translations[titleKey]) {
      titleKey = "SYSTOTPTitle"
    }
    let title = T(titleKey)

    dialogHolderParams = {
      title: () => title,
      body: () => this.getBody(),
      footer: () => this.getFooter(),
    }

    return await DialogGet(this, dialogHolderParams)
  }
  async connectedCallback() {
    this.addEventListener("pointerdown", this.pointerDownEvent)
    await super.connectedCallback()
  }
  async disconnectedCallback() {
    this.removeEventListener("pointerdown", this.pointerDownEvent)

    // doesn't work because the dom element is already removed at this stage
    // if (this.keyDownHandlerAdded) {
    //   for (let i = 1; i <= 6; i++) {
    //     document
    //       .getElementById(`SYSTOTP_${this.dialogState.instance}_TOTPDigit${i}`)
    //       .removeEventListener("keydown", (e) => this.keyDownEvent(e))
    //   }
    // }
    await super.disconnectedCallback()
  }

  async updated() {
    if (
      !this.keyDownHandlerAdded &&
      document.getElementById(`SYSTOTP_${this.dialogState.instance}_TOTPDigit6`)
    ) {
      this.keyDownHandlerAdded = true
      for (let i = 1; i <= 6; i++) {
        document
          .getElementById(`SYSTOTP_${this.dialogState.instance}_TOTPDigit${i}`)
          .addEventListener("keydown", (e) => this.keyDownEvent(e))
      }
    }
    await super.updated()
  }

  async keyDownEvent(e: KeyboardEvent) {
    let target = <HTMLInputElement>e.target
    let currentIdx = parseInt(
      target.id.replace(`SYSTOTP_${this.dialogState.instance}_TOTPDigit`, "")
    )
    if (currentIdx > 0 && currentIdx < 7) {
      if (
        (target.value === "" && e.key === "Backspace") ||
        e.key === "ArrowLeft"
      ) {
        e.preventDefault()
        let newIndex = currentIdx - 1
        if (newIndex > 6) {
          newIndex = 1
        }
        if (newIndex < 1) {
          newIndex = 6
        }

        FocusSet(`SYSTOTP_${this.dialogState.instance}_TOTPDigit${newIndex}`)
      }
    }
  }

  async pointerDownEvent(e: Event) {
    // doesn't seem to work on ios
    // but nevertheless i leave it for the android users
    try {
      if (navigator.clipboard?.readText) {
        if (!FormIsLocked(this.formState) && !ProcessIsRunning("SYSTOTP")) {
          if (isMobile()) {
            const text = await (await navigator.clipboard.readText()).trim()
            if (text) {
              if (text.length === 6 && /^\d+$/.test(text)) {
                await FieldSetVal(this.formState.fields.TOTPDigit1, text)
              }
            }
          }
        }
      }
    } catch {}
  }
}
